import { createFileRoute } from "@tanstack/react-router";
import { AddProductPage } from "@/components/inventory/AddProductPage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/inventory_/new_/product")({
  beforeLoad: () => {
    requireAuth();
  },
  component: AddProductPage,
});
